import React from "react";
import type { MarketDataGridProps } from "./types";

// Format price helper - always show integers
const formatPrice = (value: number) => Math.round(value).toString();

export const MarketDataGrid: React.FC<MarketDataGridProps> = ({
  topBidPrice,
  topBidQuantity,
  topAskPrice,
  topAskQuantity,
  onPriceClick,
}) => {
  return (
    <div className="rounded-2xl border border-border bg-background-card p-3 md:p-3.5">
      <div className="grid grid-cols-4 gap-0">
        {/* BUY SIZE */}
        <div className="border-r border-border-subtle px-1 text-center">
          <div className="mb-1 font-display text-[15px] font-bold uppercase text-foreground-subtle">BID SZ</div>
          <div className="font-display text-[26px] font-bold text-success">
            {topBidQuantity != null ? topBidQuantity : "—"}
          </div>
        </div>

        {/* BID - Clickable to fill price */}
        <div
          onClick={() => onPriceClick(topBidPrice ?? null)}
          className={`border-r border-border-subtle px-1 text-center transition-colors md:px-2 ${
            topBidPrice != null
              ? "cursor-pointer hover:bg-slate-800 active:bg-slate-700 rounded"
              : ""
          }`}
        >
          <div className="mb-1 font-display text-[15px] font-bold uppercase text-foreground-subtle">BID</div>
          {topBidPrice != null ? (
            <>
              <div className="font-display text-[26px] font-bold text-success">
                {formatPrice(topBidPrice)}
              </div>
            </>
          ) : (
            <div className="font-display text-[26px] text-foreground-faint">—</div>
          )}
        </div>

        {/* ASK - Clickable to fill price */}
        <div
          onClick={() => onPriceClick(topAskPrice ?? null)}
          className={`border-r border-border-subtle px-1 text-center transition-colors md:px-2 ${
            topAskPrice != null
              ? "cursor-pointer hover:bg-slate-800 active:bg-slate-700 rounded"
              : ""
          }`}
        >
          <div className="mb-1 font-display text-[15px] font-bold uppercase text-foreground-subtle">ASK</div>
          {topAskPrice != null ? (
            <>
              <div className="font-display text-[26px] font-bold text-danger">
                {formatPrice(topAskPrice)}
              </div>
            </>
          ) : (
            <div className="font-display text-[26px] text-foreground-faint">—</div>
          )}
        </div>

        {/* SELL SIZE */}
        <div className="px-1 text-center">
          <div className="mb-1 font-display text-[15px] font-bold uppercase text-foreground-subtle">ASK SZ</div>
          <div className="font-display text-[26px] font-bold text-danger">
            {topAskQuantity != null ? topAskQuantity : "—"}
          </div>
        </div>
      </div>
    </div>
  );
};
